import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonneMoraleDirectorContainer extends DivContainer {
	static className = "PersonneMoraleDirectorContainer";
	
  	constructor() {
	    super();
	    this.content = () => html`
		<row-wrapper>
			<select-from-api label="Qualité *" api-url="${window.APP_URL.api.directorType}" required value="0" null-option-text="Choisir une nature" null-option-value="0" name="id_director_type"></select-from-api>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Dénomination *" required name="denomination"></text-field>
		</row-wrapper>
		<row-wrapper>
			<select-from-api label="Forme juridique *" api-url="${window.APP_URL.api.legalForm}" required value="0"
				null-option-text="Forme Juridique" null-option-value="0" name="id_legal_form" discard-legal-form="true"></select-from-api>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Adresse *" required name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville></autocomplete-ville>
		<rcs-number-field label="Numéro de RCS *" required></rcs-number-field>
		<row-with-tooltip tooltip-text="La ville du greffe dépend de l'adresse de siège social.">
			<text-field label="Greffe *" required name="greffe"></text-field>
		</row-with-tooltip>
	    `;
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-morale-director", PersonneMoraleDirectorContainer);
